var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trackcode-list-page"},[_c('TrackCodes',{attrs:{"progressCode":[120, 130, 140, 150, 170, 180, 210],"isPaid":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }